<script>

	import { writable } from 'svelte/store';
  	const modal = writable(null);

	import Router from 'svelte-spa-router'
	import Dash from './Dash.svelte'
	import Match4 from './Match4.svelte'
	import Draw3 from './Draw.svelte'
	import Leadboard from './Leaderboard.svelte'
	import MoveLeadboard from './MoveLeaderboard.svelte'
	import HabitatLeadboard from './HabitatLeaderboard.svelte'
	import Home from './Home.svelte'
	import Snake from './Snake.svelte'
	import Login from './Login.svelte'
	import Stats from './Stats.svelte'
	import Feed from './Feed.svelte'
	import FeedItem from './FeedItem.svelte'
	import Marketplace from './Marketplace.svelte'
	import Battle from './Battle.svelte'
	import StageBattle from './StageBattle.svelte'
	import Artifacts from './Artifacts.svelte'
	import Habitat from './Habitat.svelte';
	import HabitatPlaces from './HabitatPlaces.svelte';
	import Map from './Map.svelte';
	import HabitatVote from './HabitatVote.svelte';
	import Link from './Link.svelte';
	import Challenge from './Challenge.svelte';
	import Chat from './Chat.svelte';
	import Go from './Go.svelte';
//	import World42 from './World42.svelte';
	import Map42 from './Map42.svelte';

	//import Spinner from './Spinner.svelte';

	const routes = {
    	// Exact path
    	'/': Home,
    	// Using named parameters, with last being optional
        '/dash/:t/:cb/:action_id?': Dash,
		'/leaderboard/:t/:id/:type_id': Leadboard,
		'/move_leaderboard/:t/:id/:type_id': MoveLeadboard,
		'/habitat_leaderboard/:t/:id/:type_id': HabitatLeadboard,
		'/habitat_vote/:t/:id/:type_id': HabitatVote,
        '/match4/:t/:id': Match4,
        '/draw3/:t/:id': Draw3,
		'/move/:t/:id': Snake,
		'/log/:t/:cb/:page?': Login,
		'/stats/:t/:id/:m_id': Stats,
		'/feed/:t/:cb': Feed,
		'/marketplace/:t/:cb': Marketplace,
		'/i/:t/:item_id': FeedItem,
		'/battle/:t/:id/:m_id': Battle,
		'/stage_battle/:t/:cb': StageBattle,
		'/artifacts/:t/:cb': Artifacts,
		'/habitat/:t/:h_id/:is_chest?': Habitat,
		'/habitat_places/:t/:h_id': HabitatPlaces,
		'/map/:t/:r/:m?': Map,
		'/link/:t/:id': Link,
		'/chall/:t/:id': Challenge,
		'/chat/:t/:id': Chat,
		'/go/:t/:s/:a1?': Go,
//		'/world/:t/:h_id': World42,
		'/map42/:t/:h_id/:m_loc_id?': Map42,
		//'/spinner': Spinner,
    	// Catch-all
    	// This is optional, but if present it must be the last
    	//'*': NotFound,
	}

</script>

<style>

:global(body, html){
		background-color: #000;
		height: 900px;
		overflow-x: hidden;
		overflow-y: hidden;
		background-image: url("/img/nyc_bg_sm.jpeg");
		background-position: center; /* Center the image */
		background-repeat: no-repeat; /* Do not repeat the image */
		background-size: cover; /* Resize the background image to cover the entire container */
		-webkit-touch-callout: none;
		-webkit-user-select: none;
		-khtml-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		touch-action: manipulation;
		overflow: hidden;
		-webkit-appearance: none;
		overscroll-behavior: none;
	}

:global(a) {
  -webkit-tap-highlight-color: transparent;
}

:global(a:link) {
	text-decoration: none;
}
:global(a:visited) {
	text-decoration: none;
}
:global(a:hover) {
	text-decoration: none;
}
:global(a:active) {
	text-decoration: none;
}
:global(*) {
	touch-action: manipulation;
}

</style>

<Router {routes}/>